import { useTheme } from "@mui/material"

const useStyles = () => {
    const { palette } = useTheme()
    return {
        container: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            padding: '8px 24px',
            border: `2px solid ${palette.grey[400]}`,
            borderRadius: 1
        },
        actions: {
            display: 'flex',
            alignItems: 'center',
        },
        date: {
            display: 'flex',
            flexDirection: 'column',
        }
    }
}

export { useStyles }